module.exports = __webpack_public_path__ + "img/bg3301.d500999b.jpg";